/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ attachments: NonNullable<unknown>, items: NonNullable<unknown> }} Zotero_Browser_Imported_SummaryInputs */

const en_zotero_browser_imported_summary = /** @type {(inputs: Zotero_Browser_Imported_SummaryInputs) => LocalizedString} */ (i) => {const attachmentsPlural = registry.plural("en", i?.attachments, {});
	const itemsPlural = registry.plural("en", i?.items, {});
	if (attachmentsPlural === "one" && itemsPlural === "one") return /** @type {LocalizedString} */ (`Imported ${i?.attachments} file from ${i?.items} item`);
	if (attachmentsPlural === "one" && itemsPlural === "other") return /** @type {LocalizedString} */ (`Imported ${i?.attachments} file from ${i?.items} items`);
	if (attachmentsPlural === "other" && itemsPlural === "one") return /** @type {LocalizedString} */ (`Imported ${i?.attachments} files from ${i?.items} item`);
	if (attachmentsPlural === "other" && itemsPlural === "other") return /** @type {LocalizedString} */ (`Imported ${i?.attachments} files from ${i?.items} items`);
	return /** @type {LocalizedString} */ ("zotero_browser_imported_summary");
};

const es_zotero_browser_imported_summary = /** @type {(inputs: Zotero_Browser_Imported_SummaryInputs) => LocalizedString} */ (i) => {const attachmentsPlural = registry.plural("es", i?.attachments, {});
	const itemsPlural = registry.plural("es", i?.items, {});
	if (attachmentsPlural === "one" && itemsPlural === "one") return /** @type {LocalizedString} */ (`Se importó ${i?.attachments} archivo de ${i?.items} elemento`);
	if (attachmentsPlural === "one" && itemsPlural === "other") return /** @type {LocalizedString} */ (`Se importó ${i?.attachments} archivo de ${i?.items} elementos`);
	if (attachmentsPlural === "other" && itemsPlural === "one") return /** @type {LocalizedString} */ (`Se importaron ${i?.attachments} archivos de ${i?.items} elemento`);
	if (attachmentsPlural === "other" && itemsPlural === "other") return /** @type {LocalizedString} */ (`Se importaron ${i?.attachments} archivos de ${i?.items} elementos`);
	return /** @type {LocalizedString} */ ("zotero_browser_imported_summary");
};

/**
* | attachmentsPlural | itemsPlural | output |
* | --- | --- | --- |
* | "one" | "one" | "Imported {attachments} file from {items} item" |
* | "one" | "other" | "Imported {attachments} file from {items} items" |
* | "other" | "one" | "Imported {attachments} files from {items} item" |
* | "other" | "other" | "Imported {attachments} files from {items} items" |
*
* @param {Zotero_Browser_Imported_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_imported_summary = /** @type {((inputs: Zotero_Browser_Imported_SummaryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_Imported_SummaryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_imported_summary(inputs)
	return en_zotero_browser_imported_summary(inputs)
});